export default {"src":"/_next/static/media/mondial-logo-mark-black-rgb.ece79883.svg","height":412,"width":564,"blurWidth":0,"blurHeight":0};